export default __webpack_public_path__ + "static/2-235490ff3c6b74f0d3a6ea0094b23d17.webp";